<script>

import { FilterMatchMode } from 'primevue/api';
import Utils from '@/common/Utils';
import CommonConstants from '@/common/Constants';
import Service from '@/services/stock-management';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue'
import GenericDateTimeMaskV2 from '@/components/generic/GenericDateTimeMaskV2.vue'
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import LabelField from '@/components/generic/LabelField.vue'

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        GenericCustomMasterDataAutocompleteV2,
        GenericCustomAutocompleteV2,
        ResponsiveButton,
        GenericDateTimeMaskV2,
        LabelField
    },
    mounted() {
        this.$store.dispatch('security/setNavbarTitle', 'StockManagementInventory.page_title');
    },
    created() {

    },
    data() {
        return {
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(), -1),
                idRegistryPlant: 2  //isab sud
            },
            twentyFour: '24.00',
            showProvenance: false,
            submitted: false,
            headerData: null,
            liquidData: [],
            liquidDataFiltered: [],
            selectedLiquidItems: [],
            gasData: [],
            gasDataFiltered: [],
            selectedGasItems: [],
            liquidGridFilters: {
                measureDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
                tankCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isOutOfService: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isHidden: { value: null, matchMode: FilterMatchMode.CONTAINS },
                lastChangedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
                audit: { value: null, matchMode: FilterMatchMode.CONTAINS },
                schedulingNotes: { value: null, matchMode: FilterMatchMode.CONTAINS },
                notes: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isValidated: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            gasGridFilters: {
                measureDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
                tankCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isOutOfService: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isHidden: { value: null, matchMode: FilterMatchMode.CONTAINS },
                lastChangedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
                audit: { value: null, matchMode: FilterMatchMode.CONTAINS },
                schedulingNotes: { value: null, matchMode: FilterMatchMode.CONTAINS },
                notes: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isValidated: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            editedRows: [],
            newInventoryReferenceDate: null,
            inventoryElaboration: null,
            inventoryElaborationProcessLog: [],
            inventoryElaborationListPanelVisible: false,
            liquidGridLoading: false,
            gasGridLoading: false,
            editMap: {},
            liquidGridVisible: true,
            gasGridVisible: false,
            createNewInventoryVisible: false,
            stockTakeId: null,
            labelStockTakeSelected: null,

            creatingNewInventoryStep1Loading: false,
            creatingNewInventoryStep2Loading: false,
            creatingNewInventoryStep3Loading: false
        }
    },
    validations() {
        return {
            filters: {
                referenceDate: { required }
            },
            newInventoryReferenceDate: { required }
        }
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
    },
    methods: {
        loadGrid() {
            this.submitted = true;
            this.liquidData = [];
            this.gasData = [];
            this.headerData = null;

            let filters = this.prepareFilters();
            this.liquidGridLoading = true;
            this.gasGridLoading = true;

            Service.getInventoryRegistryLiquidData(filters, response => {
                this.liquidGridLoading = false;
                if (response.success) {
                    this.liquidData = response.data;
                    if(response.data.length > 0){
                        this.headerData = {
                            inventoryVersion: response.data[0].inventoryVersion,
                            isInventoryPublished: response.data[0].isInventoryPublished,
                            inventoryCreatedBy: response.data[0].inventoryCreatedBy,
                            inventoryCreatedAt: response.data[0].inventoryCreatedAt,
                            inventoryPublishedBy: response.data[0].inventoryPublishedBy,
                            inventoryPublishedAt: response.data[0].inventoryPublishedAt
                        };

                        this.selectedLiquidItems = this.liquidData.filter(x => x.isIncludedInInventoryElaboration);
                    }
                }
            });

            Service.getInventoryRegistryGasData(filters, response => {
                this.gasGridLoading = false;
                
                if (response.success) {
                    this.gasData = response.data;

                    if(response.data.length > 0){
                        this.selectedGasItems = this.gasData.filter(x => x.isIncludedInInventoryElaboration);
                    }
                }
            });
        },
        prepareFilters() {
            let filters = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                idRegistryPlant: this.filters.idRegistryPlant
            };

            let cacheData = {
                name: 'StockManagementInventory',
                filters: filters
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);

            return filters;
        },
        onExportInventoryRegistryExcel() {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }
            
            let request = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            };

            this.$store.dispatch("generic/setLoading", true);
            let fileNameWithExtension = "Stock Take " + Utils.formatMonthYearLocale(this.filters.referenceDate) + ".xlsx";

            Service.exportInventoryRegistryExcel(request, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
        
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        onExportReportDeltaInventoryExcel() {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }
            
            let request = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            };

            this.$store.dispatch("generic/setLoading", true);
            let fileNameWithExtension = "Inventory Delta " + Utils.formatMonthYearLocale(this.filters.referenceDate) + ".xlsx";

            Service.exportInventoryReportDeltaExcel(request, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
        
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        startEditItem(data){
            this.editMap[data.id] = true;
            this.editedRows= [...this.editedRows, data];
        },
        cancelEditItem(data){
            this.editedRows = this.editedRows.filter(r => r.id !== data.id);
            this.editMap[data.id] = false;

        },
        onRowEditSave(data) {

            let request = {
                ...data
            };

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('StockManagementInventory.Msg.confirm'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.cancelEditItem(data);
                    this.$store.dispatch("generic/setLoading", true);
                    Service.updateInventoryRegistryItem(request, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            // this.loadGrid();
                            this.refreshRecord({...response.data});
                        } else if (response.message == 'StockManagementInventory.Msg.RecordLocked') {
                            this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.RecordLocked') + response.data + '.', life: 3000, severity: 'error' });
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    this.cancelEditItem(data);
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onFilterLiquid(event) {
            this.liquidDataFiltered = event.filteredValue;
        },
        onFilterGas(event) {
            this.gasDataFiltered = event.filteredValue;
        },
        formatMeasureDate(value) {
            return Utils.formatDateTime(Utils.dateToCurrentTimeZone(value));
        },
        openNewInventory(){
            this.createNewInventoryVisible = true;
            this.creatingNewInventoryStep1Loading = false;
            this.creatingNewInventoryStep2Loading =false;
        },
        createNewInventoryStep1(){
            if (!this.stockTakeId) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }

            this.creatingNewInventoryStep1Loading = true;
        },
        createNewInventoryStep2(){
            let request = {
                idStockTake: this.stockTakeId,
                force: false
            };
            this.creatingNewInventoryStep2Loading = true;
            this.$store.dispatch("generic/setLoading", true);
            Service.createNewInventory(request, response => {
                this.createNewInventoryVisible = false;
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    this.loadGrid();
                } else {
                    if(response.message && response.message == "StockManagementInventory.Msg.CannotCreateInventoryRefDate") {
                        //chiedo all'utente se vuole forzare la creazione di un nuovo inventario
                        //this.$confirm.close();
                        
                        this.$confirm.require({
                            group: 'confirmDialog',
                            message: this.$t('StockManagementInventory.Msg.forceNewInventoryCreation') + '</b>?<br/><br/>' + this.$t('StockManagementInventory.Msg.allDataWillBeDeleted'),
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: this.$t('yes'),
                            rejectLabel: this.$t('no'),
                            accept: () => {
                                let request = {
                                    idStockTake: this.stockTakeId,
                                    force: true
                                };

                                this.$store.dispatch("generic/setLoading", true);
                                Service.createNewInventory(request, response => {
                                    this.$store.dispatch("generic/setLoading", false);
                                    if (response.success) {
                                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                                        this.loadGrid();
                                    } else {
                                        this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                                    }
                                });
                            },
                            reject: () => {
                                //callback to execute when user rejects the action
                                this.$confirm.close();
                            }
                        });
                    }
                    else {
                        this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                }
            });
        },
        createNewInventory() {
            if (!this.stockTakeId) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.labelStockTakeSelected,
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    

                    //this.$store.dispatch("generic/setLoading", true);
                    Service.createNewInventory(request, response => {
                        //this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.loadGrid();
                        } else {
                            if(response.message && response.message == "StockManagementInventory.Msg.CannotCreateInventoryRefDate") {
                                //chiedo all'utente se vuole forzare la creazione di un nuovo inventario
                                //this.$confirm.close();
                                
                                this.$confirm.require({
                                    group: 'confirmDialog',
                                    message: this.$t('StockManagementInventory.Msg.forceNewInventoryCreation') + '</b>?<br/><br/>' + this.$t('StockManagementInventory.Msg.allDataWillBeDeleted'),
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: this.$t('yes'),
                                    rejectLabel: this.$t('no'),
                                    accept: () => {
                                        let request = {
                                            idStockTake: this.stockTakeId,
                                            force: true
                                        };

                                        //this.$store.dispatch("generic/setLoading", true);
                                        Service.createNewInventory(request, response => {
                                            //this.$store.dispatch("generic/setLoading", false);
                                            if (response.success) {
                                                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                                                this.loadGrid();
                                            } else {
                                                this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                                            }
                                        });
                                    },
                                    reject: () => {
                                        //callback to execute when user rejects the action
                                        this.$confirm.close();
                                    }
                                });
                            }
                            else {
                                this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                            }
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        publishInventory(publish) {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('StockManagementInventory.Msg.confirm'),
                icon: 'pi pi-question-circle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let request = {
                        referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                        publish: publish
                    };

                    this.$store.dispatch("generic/setLoading", true);
                    Service.publishInventory(request, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.loadGrid();
                        }
                        else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        validateInventoryRegistryAllLiquid(valid) {
            this.validateInventoryRegistryItems(valid, this.liquidDataFiltered);
        },
        validateInventoryRegistryAllGas(valid) {
            this.validateInventoryRegistryItems(valid, this.gasDataFiltered);
        },
        validateInventoryRegistryItemSingle(valid, item) {
            let data = [];
            data.push(item);

            this.validateInventoryRegistryItems(valid, data);
        },
        validateInventoryRegistryItems(valid, data) {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }
            
            if (data.length == 0) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.noSelectedInventoryItems'), life: 3000, severity: 'error' });
                return;
            }

            let request = {
                itemsList: [],
                validate: valid
            }

            for (let i = 0; i < data.length; i++) {
                request.itemsList.push(data[i].id);
            }

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('StockManagementInventory.Msg.confirm'),
                icon: 'pi pi-question-circle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.validateInventoryRegistryItems(request, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.loadGrid();
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        refreshRecord(data){

            if(data.isGas){
                let recordDataIndex = this.gasData.findIndex(x => x.id == data.id);
                this.gasData[recordDataIndex] = {...data}; 
            }else{
                let recordDataIndex = this.liquidData.findIndex(x => x.id == data.id);
                this.liquidData[recordDataIndex] = {...data}; 
            }

        },
        lockUnlockInventoryRegistryItem(locked, data) {
            let request = {
                itemId: data.id,
                lockRecord: locked,
                force: false
            }

            this.$store.dispatch("generic/setLoading", true);
            Service.lockUnlockInventoryRegistryItems(request, response => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    // this.loadGrid();
                    this.refreshRecord({...response.data});
                } else if (response.message == 'StockManagementInventory.Msg.RecordLocked') {
                    this.$confirm.require({
                        group: 'confirmDialog',
                        message: this.$t('StockManagementInventory.Msg.RecordLocked') + response.data + '.<br/><br/>' + this.$t('StockManagementInventory.Msg.RecordUnlockForce'),
                        icon: 'pi pi-question-circle',
                        acceptLabel: this.$t('yes'),
                        rejectLabel: this.$t('no'),
                        accept: () => {
                            request.force = true;
                            this.$store.dispatch("generic/setLoading", true);
                            Service.lockUnlockInventoryRegistryItems(request, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if (response.success) {
                                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                                    // this.loadGrid();
                                    this.refreshRecord({...response.data});
                                } else {
                                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                                }
                            });
                        },
                        reject: () => {
                            //callback to execute when user rejects the action
                            this.$confirm.close();
                        }
                    });
                } else if (response.message == 'StockManagementInventory.Msg.InvalidOperation') {
                    let msg = this.$t(response.message) + (locked ? this.$t('StockManagementInventory.Msg.RecordAlreadyLocked') : this.$t('StockManagementInventory.Msg.RecordAlreadyUnlocked')); 
                    this.$toast.add({ detail: msg, life: 3000, severity: 'error' });
                } else {
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },
        calculateInventoryStockLiquid() {
            this.calculateInventoryStock(this.liquidDataFiltered);
        },
        calculateInventoryStockGas() {
            this.calculateInventoryStock(this.gasDataFiltered);
        },
        calculateInventoryStock(data) {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }

            if (data.length == 0) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.noSelectedInventoryItems'), life: 3000, severity: 'error' });
                return;
            }

            let request = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                inventoryRecordToCalculateIdList: [],
            }

            for (let i = 0; i < data.length; i++) {
                request.inventoryRecordToCalculateIdList.push(data[i].id);
            }

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('StockManagementInventory.Msg.confirm'),
                icon: 'pi pi-question-circle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.calculateInventoryRegistryStock(request, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.loadGrid();
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        updateInventoryRegistryItemsByOsiPiLiquid() {
            this.updateInventoryRegistryItemsByOsiPi(this.liquidDataFiltered);
        },
        updateInventoryRegistryItemsByOsiPiGas() {
            this.updateInventoryRegistryItemsByOsiPi(this.gasDataFiltered);
        },
        updateInventoryRegistryItemsByOsiPi(data) {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }

            if (data.length == 0) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.noSelectedInventoryItems'), life: 3000, severity: 'error' });
                return;
            }

            let inventoryRecordToCalculateIdList = [];

            for (let i = 0; i < data.length; i++) {
                inventoryRecordToCalculateIdList.push(data[i].id);
            }

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('StockManagementInventory.Msg.confirm'),
                icon: 'pi pi-question-circle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.updateInventoryRegistryItemsByOsiPi(inventoryRecordToCalculateIdList, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.loadGrid();
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        startInventoryNewElaboration() {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }

            if(this.selectedLiquidItems.length == 0 && this.selectedGasItems.length == 0){
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.noSelectedInventoryItems'), life: 3000, severity: 'error' });
                return;
            }

            this.$confirm.require({
                group: 'confirmDialog',
                message: this.$t('StockManagementInventory.Msg.confirmNewInventoryElaboration') + '<b>' + Utils.formatDate(this.filters.referenceDate) + ' ' + this.$t('at').toLowerCase() + ' ' + this.twentyFour + '</b>?',
                icon: 'pi pi-question-circle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let request = {
                        referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                        itemsIdList: []
                    };

                    for (let i = 0; i < this.selectedLiquidItems.length; i++) {
                        request.itemsIdList.push(this.selectedLiquidItems[i].id);
                    }

                    for (let i = 0; i < this.selectedGasItems.length; i++) {
                        request.itemsIdList.push(this.selectedGasItems[i].id);
                    }

                    this.$store.dispatch("generic/setLoading", true);
                    Service.startNewInventoryElaboration(request, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.loadInventoryElaborationList(false);
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        loadInventoryElaborationList(silentMode) {
            if (this.v$.filters.$invalid) {
                this.$toast.add({ detail: this.$t('StockManagementInventory.Msg.invalidReferenceDate'), life: 3000, severity: 'error' });
                return;
            }
            
            let getLastReq = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            };

            if (!silentMode) {
                this.$store.dispatch("generic/setLoading", true);
            }
            Service.getStockManagementInventoryLastElaboration(getLastReq, response => {
                if (response.success && response.data != null) {
                    this.inventoryElaboration = response.data;
                    let elaborationId = this.inventoryElaboration.id;

                    Service.getStockManagementInventoryElaborationLog(elaborationId, response => {
                        if (!silentMode) {
                            this.$store.dispatch("generic/setLoading", false);
                        }
                        if (response.success) {
                            this.inventoryElaborationProcessLog = response.data;

                            if (!silentMode) {
                                this.inventoryElaborationListPanelVisible = true;
                            }
                            if (this.inventoryElaboration.status != "Aborted" && this.inventoryElaboration.status != "Completed" && this.inventoryElaborationListPanelVisible) {
                                setTimeout(() => this.loadInventoryElaborationList(true), 5000);
                            }
                        } else {
                            this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    });
                } else {
                    if (!silentMode) {
                        this.$store.dispatch("generic/setLoading", false);
                    }
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },
        continueInventoryElaboration() {
            if (this.inventoryElaboration && this.inventoryElaboration.id) {
                this.$confirm.require({
                    group: 'confirmDialog',
                    message: this.$t('StockManagementInventory.Msg.confirm'),
                    icon: 'pi pi-question-circle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        this.$store.dispatch("generic/setLoading", true);
                        Service.processNextInventoryElaborationStage(this.inventoryElaboration.id, response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if (response.success) {
                                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            } else {
                                this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                            }
                        });
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                        this.$confirm.close();
                    }
                });
            }
        },
        abortInventoryElaboration() {
            if (this.inventoryElaboration && this.inventoryElaboration.id) {
                this.$confirm.require({
                    group: 'confirmDialog',
                    message: this.$t('StockManagementInventory.Msg.confirm'),
                    icon: 'pi pi-question-circle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {
                        Service.abortInventoryElaboration(this.inventoryElaboration.id, response => {
                            if (response.success) {
                                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            } else {
                                this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                            }
                        });
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                        this.$confirm.close();
                    }
                });
            }
        },
        getInventoryElaborationStageStatusText(stage) {
            return this.$t('StockManagementInventory.inventoryElaborationStageStatus.' + stage)
        },
        formatDecimal(n, digits) {
            if (!digits) {
                digits = 2;
            }
            if (n || n == 0) {
                return n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
            }
            return null;
        },
        toggleProvenance() {
            this.showProvenance = this.showProvenance ? false : true;
        },
        getProvenance(source) {
            switch (source) {
                case 'PI':
                    return "pi-col-bg"
                case 'SIM':
                    return "sim-col-bg"
                case 'LIMS':
                    return "lims-col-bg"
                case 'Manual':
                    return "manual-col-bg"
                case 'WEB':
                    return "web-col-bg"
                case 'MTS':
                    return "mts-col-bg"
                case 'ERROR':
                    return "error-col-bg"
                default:
                    break;
            }
        },
        showGrid(liquidG){
            this.liquidGridVisible = liquidG;
            this.gasGridVisible = !liquidG;
        },
        getHeaderTooltip(){
            let headerTooltipText = "";

            if(this.headerData){
                headerTooltipText += this.$t('StockManagementInventory.createdBy') + ": " + this.headerData.inventoryCreatedBy + "\n";
                headerTooltipText += this.$t('StockManagementInventory.createdAt') + ": " + Utils.formatDateTime(Utils.dateToCurrentTimeZone(this.headerData.inventoryCreatedAt)) + "\n";
                if(this.headerData.inventoryPublishedAt){
                    headerTooltipText += this.$t('StockManagementInventory.publishedBy') + ": " + this.headerData.inventoryPublishedBy + "\n";
                    headerTooltipText += this.$t('StockManagementInventory.publishedAt') + ": " + Utils.formatDateTime(Utils.dateToCurrentTimeZone(this.headerData.inventoryPublishedAt)) + "\n";
                }
            }

            return headerTooltipText;
        },
        formatStatus(actualStage){
            return this.$t(`StockManagementInventoryDataStaging.${actualStage}`);
        },
        onStockTakeSelect(event){
            this.labelStockTakeSelected = this.$t('StockManagementInventory.Msg.confirmNewInventoryCreation') + '<b>' + event.value.label + ' - ' + this.formatStatus(event.value.extraData.actualStage) + '</b>? ';
        },
    }
}
</script>

<template>
    <main>
        <ConfirmDialog group="confirmDialog">
            <template #message="slotProps">
                <i :class="slotProps.message.icon" class="text-4xl text-primary-500 m-2"></i>
                <span v-html="slotProps.message.message" class="text-xl"></span>
            </template>
        </ConfirmDialog>

        <Dialog v-model:visible="inventoryElaborationListPanelVisible" :modal="true" style="width: 60vw;">
            <DataTable showGridlines :value="inventoryElaborationProcessLog" dataKey="id" class="p-datatable"
                stripedRows>

                <template #header>
                    <div>
                        <h2>
                            {{ $t('StockManagementInventory.btn.inventoryElaboration') }}
                        </h2>
                    </div>
                    <div class="grid">
                        <LabelField class="col-3" :label="$t('StockManagementInventory.referenceDate')"
                            :value="utils.formatDate(utils.formatDatePlusDays(new Date(inventoryElaboration.inventoryReferenceDate), -1)) + ' ' + $t('at').toLowerCase() + ' ' + twentyFour" />
                        <LabelField class="col-3" :label="$t('StockManagementInventory.status')"
                            :value="getInventoryElaborationStageStatusText(inventoryElaboration.status)" />
                        <LabelField class="col-3" :label="$t('StockManagementInventory.version')"
                            :value="inventoryElaboration.version" />
                        <div class="col-3">
                            <LabelField :label="$t('StockManagementInventory.elaborationStartedAt')"
                                :value="utils.formatDateTime(inventoryElaboration.elaborationStartedAt)" />
                            <LabelField :label="$t('StockManagementInventory.elaborationEndedAt')"
                                :value="utils.formatDateTime(inventoryElaboration.elaborationEndedAt)" />
                        </div>
                    </div>
                </template>

                <Column field="stageOrder" :header="'#'">
                </Column>
                <Column field="stage" :header="$t('StockManagementInventory.stage')">
                    <template #body="{ data, field }">
                        <span>{{ getInventoryElaborationStageStatusText(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="dailyStockReferenceDate"
                    :header="$t('StockManagementInventory.dailyStockReferenceDate')">
                    <template #body="{ data, field }">
                        <span>{{ data[field] != null ? utils.formatDate(utils.formatDatePlusDays(new Date(data[field]),
                            -1)) + ' ' + $t('at').toLowerCase() + ' ' + twentyFour : null }}</span>
                    </template>
                </Column>
                <Column field="stageStartDate" :header="$t('StockManagementInventory.stageStartDate')">
                    <template #body="{ data, field }">
                        <span>{{ data[field] != null ? utils.formatDateTime(data[field]) : null }}</span>
                    </template>
                </Column>
                <Column field="stageEndDate" :header="$t('StockManagementInventory.stageEndDate')">
                    <template #body="{ data, field }">
                        <span>{{ data[field] != null ? utils.formatDateTime(data[field]) : null }}</span>
                    </template>
                </Column>
                <Column field="errorMessage" :header="$t('StockManagementInventory.errorMessage')">
                    <template #body="{ data, field }">
                        <span>{{ data[field] ? $t('StockManagementInventory.Msg.' + data[field]) : null }}</span>
                    </template>
                </Column>
                <Column field="username" :header="$t('StockManagementInventory.elaborationUsername')">
                </Column>
                <Column field="status" :header="$t('StockManagementInventory.status')">
                    <template #body="{ data }">
                        <!-- <i class="pi" :class=getElaborationLogEntryStatusIcon(data)></i> -->
                        <i v-if="data.stageStartDate" class="pi" :class="{
                            'pi-times-circle text-red': data.errorMessage,
                            'pi-spin pi-spinner': !data.stageEndDate && !data.errorMessage,
                            'pi-check-circle text-green-500': data.stageEndDate && !data.errorMessage
                        }"></i>
                    </template>
                </Column>

                <template #footer>
                    <div class="button-container">
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.continueInventoryElaboration')"
                            icon="pi pi-play" class="mx-1 my-1 p-button-success"
                            @click="continueInventoryElaboration" />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.abortInventoryElaboration')"
                            icon="pi pi-times" class="mx-1 my-1 p-button-danger" @click="abortInventoryElaboration" />
                    </div>
                </template>

            </DataTable>
        </Dialog>


        <Dialog v-model:visible="createNewInventoryVisible" :modal="true">
            <div class="">
                <label>{{ $t('StockManagementInventoryDataStaging.selectInventory') }}</label>
                <GenericCustomAutocompleteV2
                    :onItemSelect="onStockTakeSelect"
                    v-model="stockTakeId" 
                    api="stock-take-header-combo?isFinal=true"
                    :format="{label: (x) => `${x.label} - ${formatStatus(x.extraData.actualStage)}`, value: 'value'}"
                    :class="{ 'w-full p-inputtext-sm mt-1 ': true}" />        
            </div>
            <div v-if="!creatingNewInventoryStep1Loading">
                <ResponsiveButton :label="$t('StockManagementInventory.btn.createNewInventory')" 
                    :icon="creatingNewInventoryStep1Loading ? 'fa-solid fa-spinner fa-spin' : 'pi pi-list'" class="mx-1 my-4 w-full" 
                    @click="createNewInventoryStep1" v-if="!uiPermissions('InventoryRegistryCreateBtn').isHidden"
                    :disabled="creatingNewInventoryStep1Loading" />
            </div>
            <div v-if="creatingNewInventoryStep1Loading" style="text-align: center;">
                <p v-html="labelStockTakeSelected" />
                <ResponsiveButton :label="$t('no')" 
                    icon="pi pi-times" class="mx-1 my-4" @click="createNewInventoryVisible = false" v-if="!uiPermissions('InventoryRegistryCreateBtn').isHidden"
                    :disabled="creatingNewInventoryStep2Loading" />
                <ResponsiveButton :label="$t('yes')" 
                    icon="pi pi-times" class="mx-1 my-4" @click="createNewInventoryStep2" v-if="!uiPermissions('InventoryRegistryCreateBtn').isHidden"
                    :disabled="creatingNewInventoryStep2Loading" />
            </div>
        </Dialog>


        <div class="formgrid grid">
            <div class="col-12 lg:col-1 field">
                <label for="referenceDate" :class="{'p-error':v$.filters.referenceDate.$invalid && submitted}">{{ $t('StockManagementInventory.referenceDate') }}</label>
                <Calendar 
                    :class="{ 'p-inputtext-sm w-full': true, 'p-invalid':v$.filters.referenceDate.$invalid && submitted }"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE" 
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false" 
                    v-model="filters.referenceDate" 
                    :showIcon="true" 
                    :showButtonBar="true"
                    :yearNavigator="true" 
                    />
                    <div v-if="(v$.filters.referenceDate.$invalid && submitted) || v$.filters.referenceDate.$pending.$response">
                        <small class="p-error" v-for="error in v$.filters.referenceDate.$silentErrors" :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
            </div>
            <div class="col-12 lg:col-1 field">
                <label>{{ $t('at') }}</label>
                <InputText readOnly v-model="twentyFour" class="w-full " />
            </div>
            <div class="col-12 lg:col-1 field">
                <label for="plant">{{ $t('registryPlant.fk') }}</label>
                <GenericCustomMasterDataAutocompleteV2 field="label" v-model="filters.idRegistryPlant" :addEmpty="true"
                    :emptyValue="null"
                    :emptyLabel="$t('all')"
                    name="masterdata-registry-plant-combo" api="masterdata/registry-plant-combo" />
            </div>
            <div class="col-12 lg:col-1 text-center my-2" v-if="headerData">
                <LabelField  
                    :label="$t('StockManagementInventory.version')" 
                    :value="headerData.inventoryVersion" />
                <Chip class="p-2 m-1 mr-1" 
                    v-tooltip="{ value: getHeaderTooltip() }"
                    :class="{'s-published': headerData.isInventoryPublished, 's-not-published': !headerData.isInventoryPublished}" 
                    style="min-width:50px; ">
                    <span style="margin: 0 auto;">{{ headerData.isInventoryPublished ? 
                        $t('StockManagementInventory.published') : 
                        $t('StockManagementInventory.notPublished') }}
                    </span>
                </Chip>
            </div>
            
            <div class="col-12 lg:col-6 my-5">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="loadGrid" :disabled="!uiPermissions('InventoryRegistryLoadBtn').isEnabled"/>
                <ResponsiveButton :label="$t('btn.excel')" icon="pi pi-file-excel" class="mx-1 my-1" @click="onExportInventoryRegistryExcel" :disabled="!uiPermissions('InventoryRegistryLoadBtn').isEnabled"/>
                <ResponsiveButton :label="$t('StockManagementInventory.btn.createNewInventory')" icon="pi pi-list" class="mx-1 my-1" @click="openNewInventory" v-if="!uiPermissions('InventoryRegistryCreateBtn').isHidden"/>
                <ResponsiveButton 
                    :label="!headerData.isInventoryPublished ? 
                        $t('StockManagementInventory.btn.publishInventory') : 
                        $t('StockManagementInventory.btn.publishInventoryCancel')" 
                    :icon="!headerData.isInventoryPublished ? 'pi pi-check' : 'pi pi-times'" 
                    
                    class="mx-1 my-1" @click="publishInventory(!headerData.isInventoryPublished)" v-if="headerData && !uiPermissions('InventoryRegistryCreateBtn').isHidden"/>
                <ResponsiveButton :label="$t('StockManagementInventory.btn.startInventoryNewElaboration')" icon="pi pi-list" class="mx-1 my-1" @click="startInventoryNewElaboration" v-if="!uiPermissions('InventoryStartNewElaborationBtn').isHidden"/>
                <ResponsiveButton :label="$t('StockManagementInventory.btn.inventoryElaboration')" icon="pi pi-list" class="mx-1 my-1" @click="loadInventoryElaborationList(false)" v-if="!uiPermissions('InventoryElaborationLogBtn').isHidden"/>
                <ResponsiveButton :label="$t('StockManagementDailyTank.btn.loadprovenance')" icon="pi pi-exclamation-triangle" class="mx-1 my-1" @click="toggleProvenance" />
                <span v-if="showProvenance">
                    <Chip class="p-2 m-1 mr-1 pi-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">PI</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 sim-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">SIM</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 lims-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">LIMS</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 manual-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">MANUAL</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 web-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">WEB</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 mts-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">MTS</span>
                    </Chip>
                    <Chip class="p-2 m-1 mr-1 error-col-bg" style="min-width:50px; ">
                        <span style="margin: 0 auto;">ERROR</span>
                    </Chip>

                </span>
                <ResponsiveButton :label="$t('StockManagementInventory.btn.reportOverageLoss')" icon="pi pi-file-excel" class="mx-1 my-1"
                    @click="onExportReportDeltaInventoryExcel" v-if="uiPermissions('StockSpedStageTankMeasurement').isEnabled || uiPermissions('StockBilmatStageTankMeasurement').isEnabled" />

            </div>
        </div>

        <div>
            <Button :label="$t('StockManagementInventory.liquid')" class="mx-1 my-1" :class="{'p-button-rounded p-button-text': !liquidGridVisible}" @click="showGrid(true)"  />
            <Button :label="$t('StockManagementInventory.gas')" class="mx-1 my-1" :class="{'p-button-rounded p-button-text': !gasGridVisible}" @click="showGrid(false)" />
        </div>

        <div style="height: 75vh" v-if="liquidGridVisible">
            <DataTable ref="liquidDataGrid" showGridlines v-model:filters="liquidGridFilters" filterDisplay="row"
                :value="liquidData" sortMode="single" :sortOrder="1" @filter="onFilterLiquid" 
                sortField="tankCode" editMode="row" size="small" v-model:editing-rows="editedRows"  scrollable scrollHeight="70vh" responsiveLayout="'scroll'" 
                @row-edit-save="onRowEditSave"  dataKey="id" class="p-datatable-sm" stripedRows :loading="liquidGridLoading"
                v-model:selection="selectedLiquidItems" >

                <template #header>
                    <div class="flex flex-wrap items-center justify-between gap-2">
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.validateTank')"
                            icon="pi pi-check" class="mx-1 my-1 p-button-success"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.validateTankTooltip') }"
                            @click="validateInventoryRegistryAllLiquid(true)" 
                            v-if="!uiPermissions('InventoryRegistryValidationBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.invalidateTank')"
                            icon="pi pi-times" class="mx-1 my-1 p-button-danger"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.invalidateTankTooltip') }"
                            @click="validateInventoryRegistryAllLiquid(false)"  
                            v-if="!uiPermissions('InventoryRegistryValidationBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.calculateStock')"
                            icon="pi pi-cog" class="mx-1 
                            my-1 p-button-info"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.calculateStockTooltip') }"
                            @click="calculateInventoryStockLiquid(false)"   
                            v-if="!uiPermissions('InventoryRegistryUpdatesBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.updateItemsByOsiPi')"
                            icon="pi pi-cog" class="mx-1 
                            my-1 p-button-info"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.updateItemsByOsiPiTooltip') }"
                            @click="updateInventoryRegistryItemsByOsiPiLiquid()"   
                            v-if="!uiPermissions('InventoryRegistryUpdatesBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                    </div>
                </template>

                <Column selectionMode="multiple" headerStyle="width: 3rem" v-if="!uiPermissions('InventoryStartNewElaborationBtn').isHidden"></Column>

                <Column v-tooltip="$t('StockManagementInventory.btn.editRow')" style="min-width: 150px;max-width: 150px"
                    v-if="!uiPermissions('InventoryRegistryUpdatesBtn').isHidden && !(headerData && headerData.isInventoryPublished)">
                    <template #body="{ data }">
                        <Button v-tooltip="$t('StockManagementInventory.btn.editRow')"
                            icon="pi pi-pencil"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="startEditItem(data, true)"
                            v-if="!data.isValidated && data.isRecordLocked && !editMap[data.id]" 
                        />     
                        
                        <Button v-tooltip="$t('btn.save')"
                            icon="pi pi-save"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="onRowEditSave(data, true)"
                            v-if="editMap[data.id]" 
                        />     

                        <Button v-tooltip="$t('btn.cancel')"
                            icon="pi pi-times"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1"
                            size="small" @click="cancelEditItem(data, true)"
                            v-if="editMap[data.id]" 
                        />


                        <Button v-tooltip="$t('StockManagementInventory.btn.lockItem')"
                            icon="pi pi-lock-open"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="lockUnlockInventoryRegistryItem(true, data)"
                            v-if="!data.isValidated &&  !editMap[data.id] && !data.isRecordLocked"
                            />

                        <Button v-tooltip="$t('StockManagementInventory.btn.unlockItem')"
                            icon="pi pi-lock"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1"
                            size="small" @click="lockUnlockInventoryRegistryItem(false, data)"
                            v-if="!data.isValidated &&  !editMap[data.id] && data.isRecordLocked" 
                            />


                    </template>
                </Column>

                <Column class="button-column" field="isValidated" style="min-width: 150px;max-width: 150px"
                    :header="$t('StockManagementInventory.isValidated')">
                    dataType="boolean" style="min-width: 6rem">
                    <template #body="{ data }">
                        <Button v-tooltip="$t('StockManagementInventory.btn.invalidateTank')"
                            icon="pi pi-check"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="validateInventoryRegistryItemSingle(false, data)"
                            v-if="data.isValidated" 
                            :disabled="!uiPermissions('InventoryRegistryValidationItemBtn').isEnabled || (headerData && headerData.isInventoryPublished)"
                            />
                        <Button v-tooltip="$t('StockManagementInventory.btn.validateTank')"
                            icon="pi pi-times"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1"
                            size="small" @click="validateInventoryRegistryItemSingle(true, data)"
                            v-if="!data.isValidated"  
                            :disabled="!uiPermissions('InventoryRegistryValidationItemBtn').isEnabled || (headerData && headerData.isInventoryPublished)"
                            />
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <Checkbox v-model="filterModel.value"
                            :indeterminate="filterModel.value === null" binary
                            @change="filterCallback()" />
                    </template>
                </Column>
                <Column field="tankCode" :header="$t('StockManagementInventory.tankCode')" sortable
                style="min-width: 150px;max-width: 150px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #body="slotProps">
                        <span :class="{ 'out-of-service': slotProps.data.isOutOfService === true }">
                            {{ slotProps.data.tankCode }}
                        </span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="registryProduct" :header="$t('StockManagementInventory.registryProduct')"
                    sortable style="min-width: 150px;max-width: 150px">
                    <template #body="slotProps">
                        <span :class="{ 'out-of-service': slotProps.data.isOutOfService === true }">
                            {{ slotProps.data.registryProduct }}
                        </span>
                        <span v-if="slotProps.data.idRegistryProductInventory && slotProps.data.idRegistryProduct != slotProps.data.idRegistryProductInventory" class="info"
                            v-tooltip="$t('StockManagementInventory.registryProduct') + ': ' +  slotProps.data.registryProductInventory">
                            <i class="fas fa-info-circle" />
                        </span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column dataType="date" field="measureDate"
                    :header="$t('StockManagementInventory.measureDate')" sortable style="min-width: 150px;max-width: 150px">
                    <template #filter="{ filterModel, filterCallback }">
                        <Calendar v-model="filterModel.value" dateFormat="dd/mm/yy"
                            placeholder="dd/mm/yyyy" mask="99/99/9999"
                            @keydown.enter="filterCallback()" />
                    </template>
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.measureDateSource)">{{ data[field] != null ? formatMeasureDate(data[field]) : null }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <GenericDateTimeMaskV2 v-if="!data.isValidated" class="w-full"
                            mask="99/99/9999 99:99" :unmask="true" v-model="data[field]" />
                        <span v-else>{{ data[field] != null ? formatMeasureDate(data[field]) :
                            null }}</span>
                    </template>
                </Column>
                <Column field="productLevelManual" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.productLevelManual')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.productLevelManualSource)">{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="productLevelAuto" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.productLevelAuto')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.productLevelSource)">{{
                            utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="productLevelManualVsAutoDelta" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.productLevelManualVsAutoDelta')">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="density" :header="$t('StockManagementInventory.density')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.densitySource)">{{ formatDecimal(data[field],
                            4) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="4"
                            :maxFractionDigits="4" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 4) }}</span>
                    </template>
                </Column>
                <Column field="temperatureManual" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.temperatureManual')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.temperatureManualSource)">{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                </Column>
                <Column field="temperatureAuto" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.temperatureAuto')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.temperatureSource)">{{
                            formatDecimal(data[field], 2) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                </Column>
                <Column field="temperatureManualVsAutoDelta" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.temperatureManualVsAutoDelta')">
                    <template #body="{ data, field }">
                        <span>{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                </Column>
                <Column field="waterLevel" :header="$t('StockManagementInventory.waterLevel')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.waterLevelSource)">{{
                            utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="sludgeLevel" :header="$t('StockManagementInventory.sludgeLevel')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="weightInKg" :header="$t('StockManagementInventory.weightInKg')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                        <span v-if="data.weightInKgDailyStock != null" class="info"
                            v-tooltip="$t('StockManagementInventory.weightInKgDailyStock') + ': ' + utils.formatInteger(data.weightInKgDailyStock)">
                            <i class="fas fa-info-circle" />
                        </span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="volumeInLt" :header="$t('StockManagementInventory.volumeInLt')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                        <span v-if="data.volumeInLtDailyStock != null" class="info"
                            v-tooltip="$t('StockManagementInventory.volumeInLtDailyStock') + ': ' + utils.formatInteger(data.volumeInLtDailyStock)">
                            <i class="fas fa-info-circle" />
                        </span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="waterVolumeInLt"
                    :header="$t('StockManagementInventory.waterVolumeInLt')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                        <span v-if="data.waterVolumeInLtDailyStock != null" class="info"
                            v-tooltip="$t('StockManagementInventory.waterVolumeInLtDailyStock') + ': ' + utils.formatInteger(data.waterVolumeInLtDailyStock)">
                            <i class="fas fa-info-circle" />
                        </span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="theoreticalVolumeInLt" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.theoreticalVolumeInLt')">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="technicalVolumeInLt" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.technicalVolumeInLt')">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="lastChangedBy" :header="$t('StockManagementInventory.lastChangedBy')" style="min-width: 100px;max-width: 100px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="audit" :header="$t('StockManagementInventory.audit')" style="min-width: 100px;max-width: 100px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" class="w-full" v-if="!data.isValidated" />
                        <span v-else>{{ data[field] }}</span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="schedulingNotes" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.schedulingNotes')">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" class="w-full" v-if="!data.isValidated" />
                        <span v-else>{{ data[field] }}</span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="notes" :header="$t('StockManagementInventory.notes')" style="min-width: 100px;max-width: 100px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" class="w-full" v-if="!data.isValidated" />
                        <span v-else>{{ data[field] }}</span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
            </DataTable>
        </div>
        <div style="height: 75vh" v-if="gasGridVisible">
            <DataTable showGridlines v-model:filters="gasGridFilters" filterDisplay="row"
                :value="gasData" sortMode="single" :sortOrder="1" @filter="onFilterGas"
                sortField="tankCode" editMode="row" size="small" v-model:editing-rows="editedRows" scrollable scrollHeight="70vh" responsiveLayout="'scroll'" 
                @row-edit-save="onRowEditSave" dataKey="id" class="p-datatable-sm" stripedRows
                :virtualScrollerOptions="{ itemSize: 50 }" :loading="gasGridLoading"
                v-model:selection="selectedGasItems">

                <template #header>
                    <div class="flex flex-wrap items-center justify-between gap-2">
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.validateTank')"
                            icon="pi pi-check" class="mx-1 my-1 p-button-success"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.validateTankTooltip') }"
                            @click="validateInventoryRegistryAllGas(true)"  
                            v-if="!uiPermissions('InventoryRegistryValidationBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.invalidateTank')"
                            icon="pi pi-times" class="mx-1 my-1 p-button-danger"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.invalidateTankTooltip') }"
                            @click="validateInventoryRegistryAllGas(false)"   
                            v-if="!uiPermissions('InventoryRegistryValidationBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.calculateStock')"
                            icon="pi pi-cog" class="mx-1 my-1 p-button-info"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.calculateStockTooltip') }"
                            @click="calculateInventoryStockGas(false)"    
                            v-if="!uiPermissions('InventoryRegistryUpdatesBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                        <ResponsiveButton :label="$t('StockManagementInventory.btn.updateItemsByOsiPi')"
                            icon="pi pi-cog" class="mx-1 
                            my-1 p-button-info"
                            v-tooltip="{ value: $t('StockManagementInventory.btn.updateItemsByOsiPiTooltip') }"
                            @click="updateInventoryRegistryItemsByOsiPiGas()"    
                            v-if="!uiPermissions('InventoryRegistryUpdatesBtn').isHidden"
                            :disabled="headerData && headerData.isInventoryPublished"
                            />
                    </div>
                </template>

                <Column selectionMode="multiple" headerStyle="width: 3rem" v-if="!uiPermissions('InventoryStartNewElaborationBtn').isHidden"></Column>

                <Column v-tooltip="$t('StockManagementInventory.btn.editRow')" style="min-width: 150px;max-width: 150px"
                    v-if="!uiPermissions('InventoryRegistryUpdatesBtn').isHidden && !(headerData && headerData.isInventoryPublished)">
                    <template #body="{ data }">
                        <Button v-tooltip="$t('StockManagementInventory.btn.editRow')"
                            icon="pi pi-pencil"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="startEditItem(data)"
                            v-if="!data.isValidated && data.isRecordLocked && !editMap[data.id]" 
                        />     
                        
                        <Button v-tooltip="$t('btn.save')"
                            icon="pi pi-save"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="onRowEditSave(data)"
                            v-if="editMap[data.id]" 
                        />     

                        <Button v-tooltip="$t('btn.cancel')"
                            icon="pi pi-times"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1"
                            size="small" @click="cancelEditItem(data)"
                            v-if="editMap[data.id]" 
                        />     

                        <Button v-tooltip="$t('StockManagementInventory.btn.lockItem')"
                            icon="pi pi-lock-open"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="lockUnlockInventoryRegistryItem(true, data)"
                            v-if="!data.isValidated &&  !editMap[data.id] && !data.isRecordLocked" />

                        <Button v-tooltip="$t('StockManagementInventory.btn.unlockItem')"
                            icon="pi pi-lock"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1"
                            size="small" @click="lockUnlockInventoryRegistryItem(false, data)"
                            v-if="!data.isValidated &&  !editMap[data.id] && data.isRecordLocked" />
                            
                    </template>
                </Column>

                <Column class="button-column" field="isValidated"
                    :header="$t('StockManagementInventory.isValidated')" style="min-width: 150px;max-width: 150px"
                    dataType="boolean">
                    <template #body="{ data }">
                        <Button v-tooltip="$t('StockManagementInventory.btn.invalidateTank')"
                            icon="pi pi-check"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1"
                            size="small" @click="validateInventoryRegistryItemSingle(false, data)"
                            v-if="data.isValidated"  
                            :disabled="!uiPermissions('InventoryRegistryValidationItemBtn').isEnabled || (headerData && headerData.isInventoryPublished)"
                            />
                        <Button v-tooltip="$t('StockManagementInventory.btn.validateTank')"
                            icon="pi pi-times"
                            class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1"
                            size="small" @click="validateInventoryRegistryItemSingle(true, data)"
                            v-if="!data.isValidated"  
                            :disabled="!uiPermissions('InventoryRegistryValidationItemBtn').isEnabled || (headerData && headerData.isInventoryPublished)"
                            />
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <Checkbox v-model="filterModel.value"
                            :indeterminate="filterModel.value === null" binary
                            @change="filterCallback()" />
                    </template>
                </Column>

                <Column field="tankCode" :header="$t('StockManagementInventory.tankCode')" sortable 
                    style="min-width: 150px;max-width: 150px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #body="slotProps">
                        <span :class="{ 'out-of-service': slotProps.data.isOutOfService === true }">
                            {{ slotProps.data.tankCode }}
                        </span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="registryProduct" :header="$t('StockManagementInventory.registryProduct')"
                    sortable style="min-width: 150px;max-width: 150px">
                    <template #body="slotProps">
                        <span :class="{ 'out-of-service': slotProps.data.isOutOfService === true }">
                            {{ slotProps.data.registryProduct }}
                        </span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column dataType="date" field="measureDate"
                    :header="$t('StockManagementInventory.measureDate')" sortable style="min-width: 150px;max-width: 150px">
                    <template #filter="{ filterModel, filterCallback }">
                        <Calendar v-model="filterModel.value" dateFormat="dd/mm/yy"
                            placeholder="dd/mm/yyyy" mask="99/99/9999"
                            @keydown.enter="filterCallback()" />
                    </template>
                    <template #body="{ data, field }">
                        <span>{{ data[field] != null ? formatMeasureDate(data[field]) : null }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <GenericDateTimeMaskV2 v-if="!data.isValidated" class="w-full"
                            mask="99/99/9999 99:99" :unmask="true" v-model="data[field]" />
                        <span v-else>{{ data[field] != null ? formatMeasureDate(data[field]) :
                            null }}</span>
                    </template>
                </Column>
                <Column field="productLevelAuto" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.productLevelAuto')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.productLevelSource)">{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="density" :header="$t('StockManagementInventory.density')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.densitySource)">{{ formatDecimal(data[field],
                            4) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="4"
                            :maxFractionDigits="4" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 4) }}</span>
                    </template>
                </Column>
                <Column field="temperatureAuto" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.temperatureAutoGasGrid')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.temperatureSource)">{{
                            formatDecimal(data[field], 2) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                </Column>
                <Column field="gasTemperature" :header="$t('StockManagementInventory.gasTemperature')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.gasTemperatureSource)">{{
                            formatDecimal(data[field], 2) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                </Column>
                <Column field="pressure" :header="$t('StockManagementInventory.pressure')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.pressureSource)">{{ formatDecimal(data[field],
                            3) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="3"
                            :maxFractionDigits="3" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 3) }}</span>
                    </template>
                </Column>
                <Column field="molecularWeight" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.molecularWeight')">
                    <template #body="{ data, field }">
                        <span :class="getProvenance(data.molecularWeightSource)">{{
                            formatDecimal(data[field], 2) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" v-if="!data.isValidated" />
                        <span v-else>{{ formatDecimal(data[field], 2) }}</span>
                    </template>
                </Column>
                <Column field="weightInKg" :header="$t('StockManagementInventory.weightInKg')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                        <span v-if="data.weightInKgDailyStock != null" class="info"
                            v-tooltip="$t('StockManagementInventory.weightInKgDailyStock') + ': ' + utils.formatInteger(data.weightInKgDailyStock)">
                            <i class="fas fa-info-circle" />
                        </span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="volumeInLt" :header="$t('StockManagementInventory.volumeInLt')" style="min-width: 100px;max-width: 100px">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                        <span v-if="data.volumeInLtDailyStock != null" class="info"
                            v-tooltip="$t('StockManagementInventory.volumeInLtDailyStock') + ': ' + utils.formatInteger(data.volumeInLtDailyStock)">
                            <i class="fas fa-info-circle" />
                        </span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="theoreticalVolumeInLt" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.theoreticalVolumeInLt')">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="technicalVolumeInLt" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.technicalVolumeInLt')">
                    <template #body="{ data, field }">
                        <span>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                        <InputNumber v-model="data[field]" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" v-if="!data.isValidated" />
                        <span v-else>{{ utils.formatInteger(data[field]) }}</span>
                    </template>
                </Column>
                <Column field="lastChangedBy" :header="$t('StockManagementInventory.lastChangedBy')" style="min-width: 100px;max-width: 100px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="audit" :header="$t('StockManagementInventory.audit')" style="min-width: 100px;max-width: 100px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" class="w-full" v-if="!data.isValidated" />
                        <span v-else>{{ data[field] }}</span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="schedulingNotes" style="min-width: 100px;max-width: 100px"
                    :header="$t('StockManagementInventory.schedulingNotes')">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" class="w-full" v-if="!data.isValidated" />
                        <span v-else>{{ data[field] }}</span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
                <Column field="notes" :header="$t('StockManagementInventory.notes')" style="min-width: 100px;max-width: 100px">
                    <InputText class="w-full" autoResize readonly v-model="data[field]" />
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" class="w-full" v-if="!data.isValidated" />
                        <span v-else>{{ data[field] }}</span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            class="p-column-filter" />
                    </template>
                </Column>
            </DataTable>
        </div>
    </main>
</template>

<style>
.out-of-service {
    color: red;
    font-weight: bold;
}

.text-red {
    color: red;
}

.button-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    /* Spazio tra i bottoni */
}

.s-published {
    background-color: lightgreen;
    font-weight: bold;
}

.s-not-published{
    background-color: red;
    color: white;
    font-weight: bold;
}
</style>